/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetUngatedCategoryRecsPaginatedQueryVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
  limit: Types.Scalars["Int"]["input"];
  page: Types.Scalars["Int"]["input"];
  businessLine?: Types.InputMaybe<Types.BusinessLine>;
}>;
export type GetUngatedCategoryRecsPaginatedQuery = {
  __typename?: "Query";
  shopContent?: {
    __typename?: "ShopContent";
    categoryPage?: {
      __typename?: "ShopCategoryPage";
      id: string;
      description?: string | null;
      handle?: string | null;
      category?: {
        __typename?: "ShopCategory";
        id: string;
        shopProductsByPage: {
          __typename?: "ShopProductPageConnection";
          pageCount: number;
          nodes: Array<{
            __typename: "ShopProduct";
            id: string;
            businessLine: Types.BusinessLine;
            name: string;
            brand: {
              __typename?: "Brand";
              name: string;
            };
            variantBySkuId?: {
              __typename?: "ShopProductVariant";
              id: string;
              url: string;
              price: {
                __typename?: "Money";
                currency: Types.Currency;
                value: number;
              };
              media: Array<{
                __typename?: "ShopMedia";
                altText: string;
                contentGroup: string;
                contentName: string;
                originalSrc: string;
              }>;
              promoDiscountOffer?: {
                __typename?: "PromoDiscountOffer";
                displayLabel: {
                  __typename?: "RichText";
                  formatted: string;
                };
              } | null;
            } | null;
          }>;
        };
      } | null;
      image?: {
        __typename?: "ShopCategoryImage";
        altText: string;
        baseUrl: string;
        mediaPath: string;
      } | null;
    } | null;
  } | null;
};
export type ShopProductRecommendationFragment = {
  __typename?: "ShopProduct";
  id: string;
  businessLine: Types.BusinessLine;
  name: string;
  brand: {
    __typename?: "Brand";
    name: string;
  };
  variantBySkuId?: {
    __typename?: "ShopProductVariant";
    id: string;
    url: string;
    price: {
      __typename?: "Money";
      currency: Types.Currency;
      value: number;
    };
    media: Array<{
      __typename?: "ShopMedia";
      altText: string;
      contentGroup: string;
      contentName: string;
      originalSrc: string;
    }>;
    promoDiscountOffer?: {
      __typename?: "PromoDiscountOffer";
      displayLabel: {
        __typename?: "RichText";
        formatted: string;
      };
    } | null;
  } | null;
};
export type CategoryPageHeaderFragment = {
  __typename?: "ShopCategoryPage";
  description?: string | null;
  handle?: string | null;
  image?: {
    __typename?: "ShopCategoryImage";
    altText: string;
    baseUrl: string;
    mediaPath: string;
  } | null;
};
export const ShopProductRecommendationFragmentDoc = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "ShopProductRecommendation"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "ShopProduct"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "brand"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "businessLine"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "name"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "variantBySkuId"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "price"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "currency"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "value"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "media"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "altText"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "contentGroup"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "contentName"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "originalSrc"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "promoDiscountOffer"
            },
            arguments: [{
              kind: "Argument",
              name: {
                kind: "Name",
                value: "input"
              },
              value: {
                kind: "ObjectValue",
                fields: [{
                  kind: "ObjectField",
                  name: {
                    kind: "Name",
                    value: "channel"
                  },
                  value: {
                    kind: "EnumValue",
                    value: "SHOP"
                  }
                }]
              }
            }],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "displayLabel"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "formatted"
                    }
                  }]
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "url"
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export const CategoryPageHeaderFragmentDoc = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "CategoryPageHeader"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "ShopCategoryPage"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "image"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "altText"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "baseUrl"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "mediaPath"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "description"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "handle"
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export const GetUngatedCategoryRecsPaginatedDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "getUngatedCategoryRecsPaginated"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "id"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "ID"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "limit"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Int"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "page"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Int"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "businessLine"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "BusinessLine"
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "shopContent"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "businessLine"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "businessLine"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "categoryPage"
            },
            arguments: [{
              kind: "Argument",
              name: {
                kind: "Name",
                value: "categoryId"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }
            }],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }, {
                kind: "FragmentSpread",
                name: {
                  kind: "Name",
                  value: "CategoryPageHeader"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "category"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "id"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "shopProductsByPage"
                    },
                    arguments: [{
                      kind: "Argument",
                      name: {
                        kind: "Name",
                        value: "limit"
                      },
                      value: {
                        kind: "Variable",
                        name: {
                          kind: "Name",
                          value: "limit"
                        }
                      }
                    }, {
                      kind: "Argument",
                      name: {
                        kind: "Name",
                        value: "page"
                      },
                      value: {
                        kind: "Variable",
                        name: {
                          kind: "Name",
                          value: "page"
                        }
                      }
                    }],
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "pageCount"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "nodes"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "__typename"
                            }
                          }, {
                            kind: "FragmentSpread",
                            name: {
                              kind: "Name",
                              value: "ShopProductRecommendation"
                            }
                          }]
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "CategoryPageHeader"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "ShopCategoryPage"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "image"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "altText"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "baseUrl"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "mediaPath"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "description"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "handle"
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "ShopProductRecommendation"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "ShopProduct"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "brand"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "businessLine"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "name"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "variantBySkuId"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "price"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "currency"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "value"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "media"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "altText"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "contentGroup"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "contentName"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "originalSrc"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "promoDiscountOffer"
            },
            arguments: [{
              kind: "Argument",
              name: {
                kind: "Name",
                value: "input"
              },
              value: {
                kind: "ObjectValue",
                fields: [{
                  kind: "ObjectField",
                  name: {
                    kind: "Name",
                    value: "channel"
                  },
                  value: {
                    kind: "EnumValue",
                    value: "SHOP"
                  }
                }]
              }
            }],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "displayLabel"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "formatted"
                    }
                  }]
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "url"
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;

/**
 * __useGetUngatedCategoryRecsPaginatedQuery__
 *
 * To run a query within a React component, call `useGetUngatedCategoryRecsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUngatedCategoryRecsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUngatedCategoryRecsPaginatedQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      businessLine: // value for 'businessLine'
 *   },
 * });
 */
export function useGetUngatedCategoryRecsPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetUngatedCategoryRecsPaginatedQuery, GetUngatedCategoryRecsPaginatedQueryVariables> & ({
  variables: GetUngatedCategoryRecsPaginatedQueryVariables;
  skip?: boolean;
} | {
  skip: boolean;
})) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery<GetUngatedCategoryRecsPaginatedQuery, GetUngatedCategoryRecsPaginatedQueryVariables>(GetUngatedCategoryRecsPaginatedDocument, options);
}
export function useGetUngatedCategoryRecsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUngatedCategoryRecsPaginatedQuery, GetUngatedCategoryRecsPaginatedQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery<GetUngatedCategoryRecsPaginatedQuery, GetUngatedCategoryRecsPaginatedQueryVariables>(GetUngatedCategoryRecsPaginatedDocument, options);
}
// @ts-ignore
export function useGetUngatedCategoryRecsPaginatedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUngatedCategoryRecsPaginatedQuery, GetUngatedCategoryRecsPaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<GetUngatedCategoryRecsPaginatedQuery, GetUngatedCategoryRecsPaginatedQueryVariables>;
export function useGetUngatedCategoryRecsPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUngatedCategoryRecsPaginatedQuery, GetUngatedCategoryRecsPaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<GetUngatedCategoryRecsPaginatedQuery | undefined, GetUngatedCategoryRecsPaginatedQueryVariables>;
export function useGetUngatedCategoryRecsPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUngatedCategoryRecsPaginatedQuery, GetUngatedCategoryRecsPaginatedQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery<GetUngatedCategoryRecsPaginatedQuery, GetUngatedCategoryRecsPaginatedQueryVariables>(GetUngatedCategoryRecsPaginatedDocument, options);
}
export type GetUngatedCategoryRecsPaginatedQueryHookResult = ReturnType<typeof useGetUngatedCategoryRecsPaginatedQuery>;
export type GetUngatedCategoryRecsPaginatedLazyQueryHookResult = ReturnType<typeof useGetUngatedCategoryRecsPaginatedLazyQuery>;
export type GetUngatedCategoryRecsPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetUngatedCategoryRecsPaginatedSuspenseQuery>;
export type GetUngatedCategoryRecsPaginatedQueryResult = Apollo.QueryResult<GetUngatedCategoryRecsPaginatedQuery, GetUngatedCategoryRecsPaginatedQueryVariables>;